// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatProjectsPageCard-modulecard__Oouhx AIButtonContainedGrey-moduleaiButtonContainedGrey__DeVYQ";
var _2 = "GretaAIChatProjectsPageCard-modulehead__vnvcd";
var _3 = "GretaAIChatProjectsPageCard-moduleicon__A8K9Z IconNG-moduleiconContainer__SxWZ0";
var _4 = "GretaAIChatProjectsPageCard-modulemeta__e4_wp";
var _5 = "GretaAIChatProjectsPageCard-modulename__dIkFP GretaAIChatProjectName-modulename__G5oqH";
var _6 = "GretaAIChatProjectsPageCard-modulescope__S3Ux6";
export { _1 as "card", _2 as "head", _3 as "icon", _4 as "meta", _5 as "name", _6 as "scope" }
